import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import {
  Button,
  Icon,
  IconButton,
  Modal,
  Popover as DsmPopover,
  Tooltip,
  Typography,
  Banner,
} from "@plum-xoxo/admin-dsm";
import ReportsFilter from "./components/ReportsFilter";
import UpdateReportPopup from "./components/UpdateReportPopup";
import Table from "../../../components/styled/Table";
import { NotificationManager } from "react-notifications";
import { downloadReportFromPrivateURL } from "../../../utils/reports/reportsUtils";
import {
  makeRequestAuth,
  showBaseCurrencyConversionTooltip,
} from "../../../utils/globals";
import { ACL_MODULE_MAPPING } from "../../../constants/RouteConstant";
import TotalData from "./components/TotalData";
import styled from "styled-components";
import { app_path } from "config";
import {
  isLinkResendable,
  isLinkCancellable,
} from "../../../utils/reports/reportsUtils";
import ViewDetailModal from "./ViewDetailModal";
import { isFilterApplied } from "./utils";
import { adminRole } from "../../../constants/AppConstant";
import moment from "moment";
import {
  fetchAdminList,
  fetchCampaignList,
} from "../../../actions/reportAction";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getRewardType } from "./utils";
import EmptyReports from "./components/EmptyReports";
import reportService from "../../../services/reportService";
import profileService from "../../../services/profileService";
import PaymentService from "../../../services/PaymentService";
import { GATEWAY_ID_TO_NAME_MAPPING } from "../../../constants/PaymentConstant";

const env = process.env.NODE_ENV || "production";
const config = require(`../../../config/config.${env}.json`);

const Popover = styled(DsmPopover).attrs()`
  .eui-option-child {
    font-weight: 400;
  }
`;

const HistoricalBanner = styled(Banner).attrs()`
  background-color: transparent !important;
`;

const TableComponent = (props) => {
  const {
    tableData,
    activeTab,
    initialFetchParams,
    history,
    adminList,
    xoxoCodeCampaign,
    accountReducer: {
      companyDetails,
      typeData: { role = adminRole.admin, walletCompany = 1 },
      moduleAcl = [],
      userBalance: { currencyCode = "INR" } = {},
      employeeDetails: { employee_email = "" } = {},
      kybStatus = {},
      kybStatus: { frx_enabled = 0 } = {},
      distributionType = 0,
      platformSettings: { offer_marketplace = 0 } = {},
    } = {},
    type,
    isFirstRewardSent,
  } = props;
  const [isOnlinePgAvailable, setIsOnlinePgAvailable] = useState(false);
  useEffect(() => {
    checkIfIsOnlinePgAvailable();
  }, []);
  const isProcurementApprovalRequired =
    props?.accountReducer?.platformSettings?.isProcurementApprovalRequired;
  const kyb_status = kybStatus?.kyb_status || 0;
  const title = tableData?.title?.toLowerCase();
  const moduleId = tableData?.module_id;
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [reportsData, setReportsData] = useState([]);
  const initialColumns = getUpdatedColumns([...tableData.data[0].columns]);
  const [loading, setLoading] = useState(true);
  const [count, setCount] = useState(0);
  const [hasRecords, setHasRecords] = useState(false);
  const [columns, setTableColumns] = useState(initialColumns);
  const [tpdCustomColumns, setTpdCustomColumns] = useState([]);
  const [maxDownloadRows, setMaxDownloadRows] = useState(0);
  const [fetchParams, setFetchParams] = useState(initialFetchParams);
  const [preparingToDownload, setPreparingToDownload] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [downloadReports, setDownloadReports] = useState({
    message: "",
    emailSent: false,
  });
  const [showViewDetailModal, setShowViewDetailModal] = useState(false);
  const [viewDetailModalData, setViewDetailModalData] = useState({});
  const [showHistoricalBanner, setShowHistoricalBanner] = useState(
    isFirstRewardSent || title === "payments" || title === "redemption history"
  );

  const [updateReportPopup, setUpdateReportPopup] = useState("");
  const [rewardLinkCampaign, setRewardLinkCampaign] = useState([]);

  const setColumns = (newColumns) => {
    setTableColumns(getUpdatedColumns(newColumns));
  };

  const punchout_client_ids = config?.punchout_client_ids;

  const firstUpdate = useRef(true);

  let plumPro = false;
  let moduleAclArray = moduleAcl && moduleAcl.map((item) => item.module_id);
  if (moduleAclArray.includes(ACL_MODULE_MAPPING.PLUM_PRO)) {
    plumPro = true;
  }

  const handleViewDetailsClick = (orderId = 0) => {
    if (type === "empuls_report") {
      reportService
        .companyFundRedemptionOrderDetails({
          orderId: orderId,
        })
        .then((data) => {
          setViewDetailModalData((prevState) => ({
            ...prevState,
            products: data?.data?.companyFundRedemptionOrderDetails?.data,
          }));
          setShowViewDetailModal(true);
        });
    } else {
      setShowViewDetailModal(true);
    }
  };
  const checkIfIsOnlinePgAvailable = async () => {
    const pgs = await PaymentService.getPGs();
    const pgOptions = pgs?.getPGs?.data || [];
    const onlinePGs = pgOptions?.filter((pg) => {
      const gatewayName = GATEWAY_ID_TO_NAME_MAPPING[pg.gatewayId];
      return (
        gatewayName == "razorpay" ||
        gatewayName == "stripe" ||
        gatewayName == "payoneer"
      );
    });
    onlinePGs.length
      ? setIsOnlinePgAvailable(true)
      : setIsOnlinePgAvailable(false);
  };

  function getUpdatedColumns(columns) {
    const clientId = props?.accountReducer?.clientId;
    let newColumns = [...columns];
    if (
      ((title === "reward points" ||
        title === "reward code" ||
        title === "reward link" ||
        title === "gift cards") &&
        selectedCategory === 0) ||
      ((title === "reward points" ||
        title === "reward code" ||
        title === "reward link" ||
        title === "gift cards") &&
        selectedCategory === 1)
    ) {
      newColumns[newColumns.length - 1].options = {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const showViewDetails = () => {
            if (
              type === "xoxo_token_report" &&
              (selectedCategory === 0 ||
                (title === "reward link" && selectedCategory === 1))
            ) {
              return true;
            }
            return false;
          };
          const showResend = () => {
            if (
              type === "voucher_recharge" &&
              title !== "reward code" &&
              title !== "reward points"
            ) {
              return false;
            }
            if (
              isLinkResendable(
                reportsData[tableMeta?.rowIndex],
                title === "reward link"
              ) &&
              title !== "gift cards" &&
              (selectedCategory === 0 ||
                (title === "reward link" && selectedCategory === 1))
            ) {
              return true;
            } else if (
              reportsData[
                tableMeta?.rowIndex
              ]?.delivery_status?.toLowerCase() != "pending" &&
              reportsData[
                tableMeta?.rowIndex
              ]?.delivery_status?.toLowerCase() != "canceled" &&
              title === "gift cards"
            ) {
              return true;
            }
            return false;
          };
          const showCancel = () => {
            if (
              isLinkCancellable(reportsData[tableMeta?.rowIndex]) &&
              title !== "gift cards" &&
              (selectedCategory === 0 ||
                (title === "reward link" && selectedCategory === 1))
            ) {
              return true;
            } else if (
              selectedCategory === 1 &&
              reportsData[tableMeta?.rowIndex]?.status == 2 &&
              moment(
                new Date(reportsData[tableMeta?.rowIndex]?.schedule_date),
                "DD-MM-YYYY"
              ) > moment(new Date())
            ) {
              return true;
            }
          };
          const isExpired =
            moment(
              new Date(reportsData[tableMeta?.rowIndex]?.expiry_date),
              "DD-MM-YYYY"
            ) < moment(new Date());
          return (
            <Popover
              content={
                <>
                  {showViewDetails() && (
                    <Popover.Options
                      onClick={() => {
                        document.body.click();
                        setShowViewDetailModal(true);
                      }}
                    >
                      View Details
                    </Popover.Options>
                  )}
                  {showResend() && (
                    <Tooltip
                      tooltip={
                        isExpired
                          ? "Expired"
                          : kyb_status == 6 || kyb_status == 7
                          ? "Reactivate your account to make any changes."
                          : null
                      }
                      offset={[-100, -30]}
                    >
                      <Popover.Options
                        onClick={() => {
                          if (isExpired || kyb_status == 6 || kyb_status == 7)
                            return;
                          document.body.click();
                          setUpdateReportPopup("resend");
                        }}
                        disabled={
                          isExpired || kyb_status == 6 || kyb_status == 7
                        }
                      >
                        Resend
                      </Popover.Options>
                    </Tooltip>
                  )}
                  {showCancel() && (
                    <Tooltip
                      tooltip={
                        kyb_status == 6 || kyb_status == 7
                          ? "Reactivate your account to make any changes."
                          : null
                      }
                      offset={[-100, -30]}
                    >
                      <Popover.Options
                        onClick={() => {
                          if (kyb_status == 6 || kyb_status == 7) return;
                          document.body.click();
                          setUpdateReportPopup("cancel");
                        }}
                        disabled={kyb_status == 6 || kyb_status == 7}
                      >
                        Cancel
                      </Popover.Options>
                    </Tooltip>
                  )}
                </>
              }
              offset={[0, 15]}
              onOverlayClick={() => {}}
              placement="bottom-start"
            >
              {(showViewDetails() || showResend() || showCancel()) && (
                <IconButton variant="plain">
                  <Icon iconName="Ellipsis" />
                </IconButton>
              )}
            </Popover>
          );
        },
      };
    }
    if (title === "payments" || title === "invoice payments") {
      newColumns[newColumns.length - 1].options = {
        sort: false,
        setCellHeaderProps: () => ({ className: "text-center" }),
        customBodyRender: (value, tableMeta) => {
          const showCancel = () => {
            return (
              reportsData[tableMeta?.rowIndex]?.status.toLowerCase() ===
              "finance pending"
            );
          };
          const showResend = () => {
            return (
              reportsData[tableMeta?.rowIndex]?.status.toLowerCase() !==
              "cancelled"
            );
          };
          return (
            <Popover
              content={
                <>
                  {showResend() && (
                    <Tooltip
                      tooltip={
                        kyb_status == 6 || kyb_status == 7
                          ? "Reactivate your account to make any changes."
                          : null
                      }
                      offset={[-100, -30]}
                    >
                      <Popover.Options
                        onClick={() => {
                          if (kyb_status == 6 || kyb_status == 7) return;
                          document.body.click();
                          setUpdateReportPopup("resend");
                        }}
                        disabled={kyb_status == 6 || kyb_status == 7}
                      >
                        Resend
                      </Popover.Options>
                    </Tooltip>
                  )}
                  {showCancel() && (
                    <Tooltip
                      tooltip={
                        kyb_status == 6 || kyb_status == 7
                          ? "Reactivate your account to make any changes."
                          : null
                      }
                      offset={[-100, -30]}
                    >
                      <Popover.Options
                        onClick={() => {
                          if (kyb_status == 6 || kyb_status == 7) return;
                          document.body.click();
                          setUpdateReportPopup("cancel");
                        }}
                        disabled={kyb_status == 6 || kyb_status == 7}
                      >
                        Cancel
                      </Popover.Options>
                    </Tooltip>
                  )}
                </>
              }
              offset={[0, 15]}
              onOverlayClick={() => {}}
              placement="bottom-start"
            >
              {(showCancel() || showResend()) && (
                <IconButton variant="plain">
                  <Icon iconName="Ellipsis" />
                </IconButton>
              )}
            </Popover>
          );
        },
      };
    }
    if (
      type === "xoxo_token_report" &&
      !["payments", "invoice payments"].includes(title) &&
      (selectedCategory === 0 ||
        (title === "reward link" && selectedCategory === 1))
    ) {
      newColumns[0].options = {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          return (
            <Typography
              onClick={() => {
                handleViewDetailsClick(
                  reportsData[tableMeta.rowIndex]?.order_id
                );
              }}
              color="primary"
              shade="c03"
              className="cursor-pointer"
            >
              {value}
            </Typography>
          );
        },
      };
    } else if (type === "empuls_report") {
      newColumns[0].options = {
        sort: false,
        customBodyRender: (value, tableMeta) =>
          reportsData[tableMeta.rowIndex]?.multiple_products_count > 1 ? (
            <Typography
              onClick={() => {
                handleViewDetailsClick(
                  reportsData[tableMeta.rowIndex]?.order_id
                );
              }}
              color="primary"
              shade="c03"
              className="cursor-pointer"
            >
              {value}
            </Typography>
          ) : (
            value
          ),
      };
      sendByIndex = columns.findIndex(
        (column) => column.name === "product_name"
      );
      if (sendByIndex >= 0) {
        newColumns[sendByIndex].options = {
          setCellProps: () => ({ style: { minWidth: "250px" } }),
          sort: false,
          display: true,
          customBodyRender: (value, tableMeta) => {
            const row = reportsData[tableMeta.rowIndex];
            const firstProduct = row?.product_name?.split(",")?.[0];
            return (
              <>
                <Typography component="span">
                  {firstProduct?.length > 15
                    ? `${firstProduct?.slice(0, 15)}...`
                    : firstProduct}{" "}
                  {row?.multiple_products_count > 1
                    ? `+${row?.multiple_products_count - 1}`
                    : ""}
                </Typography>
                {
                  <Typography
                    component="span"
                    color="blue"
                    shade="c02"
                  ></Typography>
                }
              </>
            );
          },
        };
      }
    } else {
      newColumns[0].options = {
        sort: false,
        customBodyRender: (value) => value,
      };
    }
    if (
      (type === "plum_pro_report" || type === "empuls_report") &&
      title === "payments"
    ) {
      newColumns[0].options = {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const row = reportsData[tableMeta.rowIndex];
          return row["status"] == "Complete" && kyb_status === 2 ? (
            <Typography
              onClick={() => {
                handleDownlaod(
                  { src: row?.signed_invoice_file },
                  "reports.pdf"
                );
              }}
              color="primary"
              shade="c02"
            >
              {value}
            </Typography>
          ) : (
            <Typography>{value}</Typography>
          );
        },
      };
    }
    // campaign
    if (type === "xoxo_token_report" && title === "reward link") {
      let sendByIndex;
      sendByIndex = columns.findIndex(
        (column) => column.name === "campaignName"
      );
      if (sendByIndex >= 0) {
        newColumns[sendByIndex].options = {
          sort: false,
          display: newColumns[sendByIndex]?.options?.display || false,
          customBodyRender: (value, tableMeta) => {
            const row = reportsData[tableMeta.rowIndex];
            return (
              <Typography
                color="dark"
                shade="c300"
                style={{ whiteSpace: "nowrap" }}
              >
                {value}
                <Typography.BodySmall
                  color="dark"
                  shade="c200"
                  style={{ whiteSpace: "nowrap" }}
                >
                  {row.products_count} Vouchers
                </Typography.BodySmall>
              </Typography>
            );
          },
        };
      }
      if (distributionType === 1) {
        sendByIndex = columns.findIndex(
          (column) => column.name === "redemption_status"
        );
        if (sendByIndex >= 0) {
          newColumns[sendByIndex].filter.filters.options = [
            ...newColumns[sendByIndex].filter.filters.options.filter(
              (status) =>
                status.value !== "expired" &&
                status.value !== "partial_redeemed"
            ),
          ];
        }

        newColumns = newColumns.filter(
          (column) => !(column.name === "expiry_date")
        );
      }
    }

    let sendByIndex;
    if (title !== "gift cards") {
      // sent by
      sendByIndex = columns.findIndex((column) => column.name === "sent_by");
      if (sendByIndex >= 0) {
        newColumns[sendByIndex].filter.filters.options = adminList;
      }
    }
    // campaign
    sendByIndex = newColumns.findIndex(
      (column) =>
        column.name === "campaign_name" || column.name === "campaignName"
    );
    if (sendByIndex >= 0) {
      if (title === "reward code") {
        newColumns[sendByIndex].filter.filters.options = xoxoCodeCampaign;
      } else if (title === "reward link") {
        newColumns[sendByIndex].filter.filters.options = rewardLinkCampaign;
      }
    }
    // amount
    if (
      type === "voucher_recharge" &&
      (title === "reward points" || title === "reward code")
    ) {
      if (selectedCategory === 0) {
        sendByIndex = columns.findIndex((column) => column.name === "amount");
        if (sendByIndex >= 0) {
          newColumns[sendByIndex].options = {
            ...newColumns[sendByIndex].options,
            customBodyRender: (value, tableMeta) => {
              return `${
                reportsData[tableMeta.rowIndex].used_amount_with_currency
              }/${reportsData[tableMeta.rowIndex].total_amount_with_currency}`;
            },
          };
        }
      } else {
        sendByIndex = columns.findIndex((column) => column.name === "amount");
        if (sendByIndex >= 0) {
          newColumns[sendByIndex].options = {
            ...newColumns[sendByIndex].options,
            customBodyRender: (value) => {
              return value;
            },
          };
        }
      }
    } else {
      let amountIndex = columns.findIndex((column) => column.name === "amount");
      if (amountIndex >= 0) {
        if (!newColumns[amountIndex]?.label?.includes(currencyCode)) {
          newColumns[amountIndex].label =
            newColumns[amountIndex].label + `(${currencyCode})`;
        }
      }
    }

    if (type === "xoxo_token_report" && title === "reward link") {
      sendByIndex = columns.findIndex(
        (column) => column.name === "redeemed_links"
      );
      if (sendByIndex >= 0) {
        newColumns[sendByIndex].options = {
          display: newColumns[sendByIndex]?.options?.display || false,
          sort: false,
          customBodyRender: (value, tableMeta) => {
            return `${reportsData[tableMeta.rowIndex].redeemed_links}/${
              reportsData[tableMeta.rowIndex].total_links
            }`;
          },
          setCellHeaderProps: () => ({ className: "text-right" }),
          setCellProps: () => ({ className: "text-right" }),
        };
      }
    }
    if (type === "xoxo_token_report" && title === "reward code") {
      sendByIndex = columns.findIndex(
        (column) => column.name === "total_amount_with_currency"
      );
      if (sendByIndex >= 0) {
        if (!newColumns[sendByIndex]?.label?.includes(currencyCode)) {
          newColumns[sendByIndex].label =
            newColumns[sendByIndex].label + `(${currencyCode})`;
        }
      }
    }
    sendByIndex = columns.findIndex(
      (column) =>
        column.name === "phone_no" ||
        column.name === "receiver_phone_number" ||
        column.name === "recipient_phone" ||
        column.name === "receiver_mobile_number"
    );
    if (sendByIndex >= 0) {
      newColumns[sendByIndex].options = {
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let phone_code =
            reportsData[tableMeta.rowIndex]?.phone_code ||
            reportsData[tableMeta.rowIndex]?.receiver_phone_code ||
            reportsData[tableMeta.rowIndex]?.receiver_mobile_code;
          const phone_no =
            reportsData[tableMeta.rowIndex]?.phone_no ||
            reportsData[tableMeta.rowIndex].receiver_phone_number ||
            reportsData[tableMeta.rowIndex].recipient_phone ||
            reportsData[tableMeta.rowIndex].receiver_mobile_number;

          return phone_no && phone_no !== "N/A"
            ? phone_code?.includes("+")
              ? `${phone_code} ${phone_no}`
              : `+${phone_code} ${phone_no}`
            : "";
        },
        setCellHeaderProps: () => ({ className: "text-right" }),
        setCellProps: () => ({
          className: "text-right",
          style: {
            whiteSpace: "nowrap",
          },
        }),
      };
    }
    if (
      title === "reward code" &&
      selectedCategory === 1 &&
      isProcurementApprovalRequired
    ) {
      let sendByIndex;
      sendByIndex = columns.findIndex(
        (column) => column.name === "schedule_date"
      );
      if (sendByIndex >= 0) {
        newColumns[sendByIndex].options = { display: false };
        newColumns[sendByIndex].checked = false;
      }
    }

    if (role === adminRole.admin && title !== "gift cards") {
      newColumns = newColumns.filter((column) => column.name !== "sent_by");
    }
    if (title === "payments" || title === "invoice payments") {
      newColumns[0].options = {
        ...(newColumns[0].options || {}),
        sort: false,
        customBodyRender: (value, tableMeta) => {
          const data = reportsData[tableMeta?.rowIndex] || {};
          if (
            (data["proforma_invoice_file"] ||
              data["signed_invoice_file"] ||
              (data["digio_signed_status"] == config.digio_signed_status &&
                data["digio_signed_file_link"] &&
                data["status"] == "Complete")) &&
            value !== "N/A" &&
            data["type"] != "Withdrawal" &&
            !data["comments"]?.includes("FundTransferredFrom") &&
            kyb_status === 2
          ) {
            return (
              <Typography
                color="primary"
                shade="c03"
                component="span"
                onClick={() => {
                  reportService.handleUrl(
                    data["digio_signed_file_link"]
                      ? config.digio_report_url + data["digio_signed_file_link"]
                      : data["proforma_invoice_file"] ||
                          data["signed_invoice_file"]
                  );
                }}
              >
                {value}
              </Typography>
            );
          }
          return <span>{value}</span>;
        },
      };
    }

    return newColumns;
  }

  const handleDownlaod = (filename) => {
    const downloadData = {
      query: "stores.mutation.fileDownload",
      tag: "stores",
      variables: {
        add_data: filename.src,
      },
    };
    makeRequestAuth(
      downloadData,
      function (resp) {
        if (resp?.data?.fileDownload?.output) {
          NotificationManager.success("Download Started");
          let response = JSON.parse(resp.data.fileDownload.output);
          let url = "data:" + response.type + ";base64," + response.data;
          downloadReportFromPrivateURL(document, url, response);
        }
      }.bind(this)
    );
  };
  const handleDownloadOutputFile = (output) => {
    NotificationManager.success("Download Started");
    let response = JSON.parse(output);
    let url = "data:" + response.type + ";base64," + response.data;
    downloadReportFromPrivateURL(document, url, response);
  };

  const callDownloadReportData = (
    newFetchParams = {},
    lastTwelveMonthsRecords
  ) => {
    let fetchParams = {
      ...initialFetchParams,
      ...newFetchParams,
    };
    if (newFetchParams?.is_historical) {
      fetchParams = { ...fetchParams, isSuperAdmin: true };
      if (title === "invoice payments" && type === "xoxo_token_report") {
        const orderStatus = ["", "pending", "Complete", "Canceled"];
        fetchParams["orderStatus"] = orderStatus[selectedCategory];
        fetchParams["isSuperAdmin"] = true;
      }
      if (title === "payments" && type === "xoxo_token_report") {
        const orderStatus = ["Completed", "Canceled"];
        fetchParams["orderStatus"] = orderStatus[selectedCategory];
        fetchParams["isSuperAdmin"] = true;
      }
    } else if (lastTwelveMonthsRecords) {
      fetchParams = {
        ...fetchParams,
        ...getFilterData(lastTwelveMonthsRecords),
      };
    } else {
      fetchParams = { ...fetchParams, ...getFilterData() };
    }
    let sentByIndex;
    if (
      type === "xoxo_token_report" ||
      type === "voucher_recharge" ||
      (type === "plum_pro_report" && title === "gift cards")
    ) {
      fetchParams["custom_header"] = newFetchParams.is_historical
        ? columns.map((ele) => ele.name)
        : columns
            .filter(
              (item) =>
                (item.defaultChecked || item?.options?.display !== false) &&
                item.name
            )
            .map((ele) => ele.name);

      if (title === "reward link") {
        // Value of Link
        sentByIndex =
          fetchParams["custom_header"].indexOf("denomination_value");
        if (sentByIndex > -1) {
          fetchParams["custom_header"][sentByIndex] = "campaignDenomination";
        }
        // Quantity
        sentByIndex = fetchParams["custom_header"].indexOf("redeemed_links");
        if (sentByIndex > -1) {
          fetchParams["custom_header"].splice(
            sentByIndex + 1,
            0,
            "total_links"
          );
        }
        // Mode of Delivery
        sentByIndex = fetchParams["custom_header"].indexOf("mode_of_delivery");
        if (sentByIndex > -1) {
          fetchParams["custom_header"][sentByIndex] = "delivery_method";
        }
        fetchParams["isBulk"] = selectedCategory == 1;

        // Start Date and End Date
        if (fetchParams["endDate"] && !lastTwelveMonthsRecords) {
          fetchParams["end_date"] = moment(
            fetchParams["endDate"],
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
          fetchParams["start_date"] = moment(
            fetchParams["startDate"],
            "YYYY-MM-DD"
          ).format("YYYY-MM-DD");
        }

        delete fetchParams["customLinkData"];
        delete fetchParams["reward_type"];
      }

      if (title !== "gift cards") {
        sentByIndex = fetchParams["custom_header"].indexOf("sent_by");
      }

      if (walletCompany === 0) {
        fetchParams["custom_header"].splice(3, 0, "used_amount_with_currency");
        fetchParams["custom_header"].splice(3, 0, "total_amount_with_currency");
      }
    }

    if (title === "reward code" || title === "reward points") {
      sentByIndex = fetchParams["custom_header"].indexOf("sent_by");
      if (sentByIndex > -1) {
        fetchParams["custom_header"][sentByIndex] = "sent_byemail";
      }
    }

    if (type === "xoxo_token_report" || type === "voucher_recharge") {
      fetchParams["report_of"] =
        tableData?.data[selectedCategory]?.downloadFile;
      if (title === "reward link") {
        fetchParams["customHeader"] = JSON.stringify(
          fetchParams["custom_header"]
        );
      }
      if (
        title === "reward code" ||
        title === "reward points" ||
        title === "payments" ||
        title === "invoice payments" ||
        title === "gift cards"
      ) {
        if (role === adminRole.superAdmin) {
          fetchParams["isMultiadmin"] = walletCompany === 1;
        }
      }
    } else if (title === "gift cards" && type === "plum_pro_report") {
      fetchParams["report_of"] =
        tableData?.data[selectedCategory]?.downloadFile;
    } else if (type === "empuls_report") {
      fetchParams["customHeader"] = columns
        .filter(
          (item) =>
            (item.defaultChecked || item?.options?.display !== false) &&
            item.name
        )
        .map((ele) => ele.name);
      fetchParams["reportName"] =
        tableData?.data[selectedCategory]?.downloadFile;
      sentByIndex = fetchParams["customHeader"].indexOf("added_date");
      if (sentByIndex > -1) {
        fetchParams["customHeader"][sentByIndex] = "order_date";
      }
    } else {
      fetchParams["reportName"] =
        tableData?.data[selectedCategory]?.downloadFile;
    }
    fetchParams["limit"] = lastTwelveMonthsRecords ? 2147483647 : count;

    setPreparingToDownload(
      lastTwelveMonthsRecords ? "last12month" : "filtered"
    );
    tableData.data[selectedCategory]
      .downloadData(fetchParams)
      .then((response) => {
        if (response?.output) {
          setPreparingToDownload(false);
          handleDownloadOutputFile(response.output);
          document.body.click();
        } else if (type === "empuls_report" && title === "payments") {
          setPreparingToDownload(false);
          document.body.click();
          setDownloadReports({
            message: response.Message || response.message,
            emailSent: true,
          });
        } else if (type === "empuls_report" && title === "redemption history") {
          setPreparingToDownload(false);
          handleDownlaod({
            src: response?.data?.awsUrl,
          });
        } else {
          const msg =
            response?.success && (response?.message || response?.Message);
          setPreparingToDownload(false);
          if (msg) {
            document.body.click();
            setDownloadReports({
              message: msg,
              emailSent: true,
            });
          } else {
            setPreparingToDownload(false);
            NotificationManager.error(
              response.error ? response.error : "Could not download report",
              "Error"
            );
          }
        }
      })
      .catch(() => {
        setPreparingToDownload(false);
        NotificationManager.error("Something Went Wrong", "Error");
      })
      .then(() => {
        // this.setState({
        //   showDownload: false,
        // });
      });
  };

  const profomaRecharge = (rowIndex) => {
    const rowData = reportsData[rowIndex];
    let leftSymbol = rowData && rowData.symbol_left ? rowData.symbol_left : "";
    let product_type;
    if (type === "voucher_recharge") {
      product_type = {
        product_type: 1,
        company_recharge: 0,
      };
    } else if (type === "xoxo_token_report") {
      product_type = {
        product_type: 4,
        company_recharge: 2,
      };
    } else if (type === "empuls_report") {
      product_type = {
        product_type: 2,
        company_recharge: 1,
      };
    } else if (type == "plum_pro_report") {
      product_type = {
        product_type: 4,
        company_recharge: 2,
      };
    }
    const data = {
      sales_order_id: rowData?.sales_order_id || "",
      contact: rowData?.billing_contact || "",
      amount:
        rowData?.amount?.replace(currencyCode, "") ||
        rowData?.total
          ?.replace(rowData?.symbol_left, "")
          ?.replace(currencyCode, "") ||
        "",
      companyDetails: companyDetails,
      currencySymbol: leftSymbol,
      is_proforma_invoice:
        rowData && rowData?.is_proforma_invoice
          ? rowData?.is_proforma_invoice
          : 0,
      redirectPage: `/${app_path}/recharge/`,
      ...product_type,
    };
    history.push({
      pathname: `/${app_path}/payment/`,
      state: JSON.stringify({ ...data }),
    });
  };

  const applyFilter = async (newColumn) => {
    setColumns(newColumn);
    setFetchParams({ ...fetchParams, offset: 0 });
    document.body.click();
  };

  const getFilterData = (last12month) => {
    let filterData = {};
    let filters = {};
    if (
      role === adminRole.superAdmin &&
      selectedCategory === 0 &&
      type === "xoxo_token_report" &&
      title !== "gift cards"
    ) {
      filterData["isSuperAdmin"] = true;
    }
    if (selectedCategory === 1) {
      filterData["reward_type"] = getRewardType(title);
      if (title === "reward code" && isProcurementApprovalRequired) {
        filterData["approvalAwaited"] = 1;
      }
    }
    if (title === "invoice payments" && type === "xoxo_token_report") {
      const orderStatus = ["", "pending", "Complete", "Canceled"];
      filterData["orderStatus"] = orderStatus[selectedCategory];
      filterData["isSuperAdmin"] = true;
    }
    if (title === "payments" && type === "xoxo_token_report") {
      const orderStatus = ["Completed", "Canceled"];
      filterData["orderStatus"] = orderStatus[selectedCategory];
      filterData["isSuperAdmin"] = true;
    }
    if (
      plumPro &&
      ["payments", "invoice payments", "gift cards"].includes(title) &&
      type === "xoxo_token_report" &&
      title !== "gift cards"
    ) {
      filterData["plumPro"] = true;
    }

    if (last12month) return filterData;

    columns.map((ele) => {
      if (ele.filter && ele.filter.filters && ele.filter.filters.length > 0) {
        let elementFilter = ele.filter.filters.filter(
          (item) => item.selected === true && item.value
        );
        if (elementFilter.length) {
          filterData[elementFilter[0].key] = elementFilter[0].value;
          if (title === "gift cards" && ele.filter.filters?.length > 1) {
            filterData[elementFilter[0].key] = {
              operation: elementFilter[0].operation,
              value: elementFilter[0].value,
            };
          }
        }
      } else if (
        ele.filter &&
        ele.filter.filters &&
        ele.filter.filters &&
        ele.filter.filterType == "date" &&
        ele.filter.filters.startDate &&
        ele.filter.filters.endDate
      ) {
        if (
          ele.name === "date" ||
          ele.name === "date_added" ||
          ele.name === "added_date"
        ) {
          filterData["start_date"] = ele.filter.filters.startDate;
          filterData["end_date"] = ele.filter.filters.endDate;
        } else if (ele.name === "generation_date") {
          filterData["generation_start_date"] = ele.filter.filters.startDate;
          filterData["generation_end_date"] = ele.filter.filters.endDate;
        } else if (ele.name == "expiry_date") {
          filterData["expiry_start_date"] = ele.filter.filters.startDate;
          filterData["expiry_end_date"] = ele.filter.filters.endDate;
        } else if (ele.name == "last_redemeed") {
          filterData["last_redemeed_start"] = ele.filter.filters.startDate;
          filterData["last_redemeed_end"] = ele.filter.filters.endDate;
        } else if (ele.name == "issued_date") {
          filterData["startDate"] = ele.filter.filters.startDate;
          filterData["endDate"] = ele.filter.filters.endDate;
        } else if (ele.name == "delivery_date") {
          filterData["deliveredStartDate"] = ele.filter.filters.startDate;
          filterData["deliveredEndDate"] = ele.filter.filters.endDate;
        } else if (ele.name == "redemption_date") {
          filterData["redemption_start_date"] = ele.filter.filters.startDate;
          filterData["redemption_end_date"] = ele.filter.filters.endDate;
        }
      } else if (
        ele?.filter?.filters &&
        ele.filter.filterType === "select" &&
        ele.filter.filters.value
      ) {
        if (ele.name == "sent_by") {
          filters["sent_by"] = parseInt(atob(ele.filter.filters.value.user_id));
        } else if (ele.name == "redemption_status") {
          filterData["redemption_status"] = ele.filter.filters.value.value;
        } else if (ele.name === "campaign_name") {
          filters[ele.name.toLowerCase()] = ele.filter.filters.value.value;
        } else if (ele.name === "campaignName") {
          filterData[ele.name.toLowerCase()] = ele.filter.filters.value.value;
        } else if (ele.name === "delivery_status") {
          filterData[ele.name.toLowerCase()] = ele.filter.filters.value.value;
        } else if (ele.name == "status") {
          if (title === "reward points") {
            filters[ele.name.toLowerCase()] = ele.filter.filters.value.value;
          } else {
            filters[ele.name.toLowerCase()] = [ele.filter.filters.value.value];
          }
        } else if (ele.name == "type") {
          filters[ele.name.toLowerCase()] = [ele.filter.filters.value.value];
        } else if (ele.name == "reason") {
          filterData[ele.name.toLowerCase()] = ele.filter.filters.value.value;
        } else if (ele.name == "tag") {
          filterData[ele.name.toLowerCase()] = ele.filter.filters.value.value;
        }
      }
    });

    if (Object.keys(filters).some((k) => k != "")) {
      filterData["filters"] = { ...filters };
    }

    if (title === "reward link") {
      const campaign_id = rewardLinkCampaign.find(
        (campaign) => campaign.value === filterData?.campaignname
      )?.campaignId;
      const sorting = fetchParams?.sorting?.split(":");
      filterData["customLinkData"] = {
        start_date: filterData?.startDate
          ? moment(filterData?.startDate, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        end_date: filterData?.endDate
          ? moment(filterData?.endDate, "YYYY-MM-DD").format("YYYY-MM-DD")
          : null,
        emailId: filterData?.emailId || null,
        batchId: filterData?.batchId || null,
        name: filterData?.name || null,
        phoneNumber: filterData?.phoneNumber || null,
        redemption_status: filterData?.redemption_status || null,
        isBulk: selectedCategory === 1,
        sortBy: (sorting && sorting[0]) || null,
        sortOrder: (sorting && sorting[1]) || null,
        unique_id: filterData?.unique_id,
        payment_reference_id: filterData?.payment_reference_id,
        redemption_start_date: filterData?.redemption_start_date || null,
        redemption_end_date: filterData?.redemption_end_date || null,
        campaign_id: campaign_id || null,
      };
      delete filterData.filters;
    }
    return filterData;
  };

  async function fetchReports(signal = false) {
    setLoading(true);
    let filterData = getFilterData();
    if (type === "empuls_report" && title === "payments") {
      filterData["client_dashboard_recharge"] = 0;
      filterData["company_recharge"] = 1;
      filterData["superadmin_recharge"] = 0;
      filterData["client_dashboard_recharge"] = 0;
    }
    const response = await tableData?.data[selectedCategory]?.fetchData(
      {
        ...fetchParams,
        ...filterData,
      },
      signal
    );
    if (signal?.aborted) {
      return;
    }
    let newReportsData = [];
    let total = 0;
    let success = 0;
    let newMaxDownloadRows = 0;
    let newHasRecords = false;
    let newTpdCustomColumns = [];

    if (title === "payments" || title === "invoice payments") {
      if (response.data?.getMultiAdminPaymentReport) {
        const data = response.data?.getMultiAdminPaymentReport;
        total = data?.total;
        newReportsData = data?.res;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      } else if (response.data?.plumProRechargeHistory) {
        const data = response.data?.plumProRechargeHistory;
        total = data?.data?.count;
        newReportsData = data?.data?.list;
        success = !data?.error;
        newHasRecords = data?.hasRecords;
      } else if (response.data?.getPlumPaymentReport) {
        const data = response.data?.getPlumPaymentReport;
        total = data?.total;
        newReportsData = data?.res;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      }
    } else if (title === "reward points") {
      if (response.data?.getMultiAdminPointsReport) {
        const data = response.data?.getMultiAdminPointsReport;
        newReportsData = data?.res;
        total = data?.total;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      } else if (response.data?.getPlumPointsReport) {
        const data = response.data?.getPlumPointsReport;
        newReportsData = data?.res;
        total = data?.total;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      } else if (response?.fetchScheduleReport) {
        const data = response?.fetchScheduleReport;
        newReportsData = data?.data?.data;
        total = data?.data?.total;
        success = data?.success || !data?.error;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      }
    } else if (title === "reward code") {
      if (response.data?.getMultiAdminVoucherReport) {
        const data = response.data?.getMultiAdminVoucherReport;
        newReportsData = data?.res;
        total = data?.total;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      } else if (response.data?.getPlumVoucherReport) {
        const data = response.data?.getPlumVoucherReport;
        newReportsData = data?.res;
        total = data?.total;
        success = data?.success;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      } else if (
        response?.fetchScheduleReport ||
        response?.data?.fetchScheduleReport
      ) {
        const data =
          response?.fetchScheduleReport || response?.data?.fetchScheduleReport;
        newReportsData = data?.data?.data;
        total = data?.data?.total;
        success = data?.success || !data?.error;
        newMaxDownloadRows = data?.maxDownloadRows;
        newHasRecords = data?.hasRecords;
      }
    } else if (title === "reward link") {
      const data = response.data?.getxoxoLinkTable;
      newReportsData = data?.data || [];
      total = data?.count;
      success = data?.success;
      newMaxDownloadRows = data?.maxDownloadRows;
      newHasRecords = data?.hasRecords;
    } else if (title === "redemption history") {
      const data = response.data?.companyFundRedemptionReport;
      total = data?.data?.count;
      newReportsData = data?.data?.list ? JSON.parse(data?.data?.list) : [];
      success = !data?.error;
      newHasRecords = data?.hasRecords;
      newTpdCustomColumns = data?.data?.tpd_custom_columns || [];
    } else if (title === "gift cards") {
      const data = response.data?.clientDashboardOrders;
      newReportsData = data?.Orders;
      total = data?.total_num;
      success = data?.Error === false;
      newMaxDownloadRows = data?.maxDownloadRows;
      newHasRecords = data?.hasRecords;
    }
    if (title === "payments" || title === "invoice payments") {
      // add currency code in amount
      newReportsData.map((report) => {
        if (report?.total) {
          report["total"] =
            (report.code || currencyCode || "") +
            " " +
            report?.total?.replace(report?.symbol_left || "", "");
        } else {
          report["amount"] =
            (report.code || currencyCode || "") +
            " " +
            report?.amount?.replace(report?.symbol_left || "", "");
        }
      });
    }
    if (type === "xoxo_token_report" && title === "gift cards") {
      newReportsData?.map((report) => {
        report["amount_charged"] =
          report["base_currency_code"] + " " + report["amount_charged"];
      });
    }
    if (
      type === "xoxo_token_report" &&
      (title === "reward points" ||
        title == "reward code" ||
        title === "reward link")
    ) {
      const DeliveryModes = ["Email", "SMS", "Email and SMS"];
      newReportsData?.map((report) => {
        if (
          report["receiver_email"] !== "" &&
          report["receiver_phone_number"] !== ""
        ) {
          report["mode_of_delivery"] = "Email and SMS";
        } else if (report["receiver_email"] !== "") {
          report["mode_of_delivery"] = "Email";
        } else {
          report["mode_of_delivery"] = "SMS";
        }
        if (Number(report?.delivery_method)) {
          report["mode_of_delivery"] =
            DeliveryModes[report?.delivery_method - 1];
        }

        if (title === "reward link" && frx_enabled) {
          report["denomination_value"] = (
            <div className="d-flex align-items-center justify-content-end">
              {showBaseCurrencyConversionTooltip(
                currencyCode,
                report["currencyCode"],
                report["redemption_status"]
              ) ? (
                <div className="mr-1">
                  <Tooltip
                    arrow
                    offset={[0, 5]}
                    placement="left"
                    tooltip={`${
                      report["value_in_basecurrency"] || 0
                    } ${currencyCode} = ${report["denomination_value"]} ${
                      report["currencyCode"]
                    }`}
                  >
                    <Icon iconName="Info" size={16} />
                  </Tooltip>
                </div>
              ) : null}
              <div>
                {report["currencyCode"] + " " + report["denomination_value"]}
              </div>
            </div>
          );
        } else if (title === "reward link") {
          report["denomination_value"] =
            report["currencyCode"] + " " + report["denomination_value"];
        }

        adminList.map((item) => {
          if (item.user_id === report["sent_by"]) {
            report["sent_by"] = item.employee_email;
          }
        });
      });
    }

    const formattedReportsData =
      type === "empuls_report" && offer_marketplace === 1
        ? newReportsData?.map((report) => {
            const denominationsValue = Number(report?.denominations) || 0;
            const discountValue =
              report?.product_discount &&
              denominationsValue &&
              Number(report?.product_discount) > 0
                ? (denominationsValue * Number(report?.product_discount)) / 100
                : 0;
            return {
              ...report,
              discountValue:
                report?.denominationCurrency +
                " " +
                parseFloat(discountValue.toFixed(2)),
            };
          })
        : [...newReportsData];

    setCount(total);
    setReportsData(formattedReportsData || []);
    setMaxDownloadRows(newMaxDownloadRows);
    setHasRecords(newHasRecords);
    if (tpdCustomColumns?.length === 0) {
      setTpdCustomColumns(newTpdCustomColumns || []);
    }
    if (success) {
      setLoading(false);
    } else {
      if (isFilterApplied(columns)) {
        setLoading(false);
        setReportsData([]);
      }
    }
  }

  const fetchRewardLinkCampaigns = () => {
    const campaings = [];
    profileService
      .fetchOneClickCampaignSites({
        offset: 0,
        limit: 1000,
      })
      .then((response) => {
        if (response?.success) {
          response?.data?.map((campaign) => {
            campaings.push({
              label: campaign.campaignName,
              value: campaign.campaignName,
              campaignId: campaign.campaignId,
            });
          });
          setRewardLinkCampaign(campaings);
        }
      });
  };

  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    setColumns(tableData.data[selectedCategory].columns);
  }, [selectedCategory]);

  useEffect(() => {
    props.fetchAdminList();
    props.fetchCampaignList();
    fetchRewardLinkCampaigns();
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    fetchReports(abortController.signal);
    setSelectedRows([]);
    return () => {
      abortController.abort();
    };
  }, [columns, fetchParams, activeTab]);

  const isSuperAdmin = role === adminRole.superAdmin ? true : false;
  const hideReportOptions = loading;
  const isFilterDisabled = loading;
  let sorting = fetchParams?.sorting?.split(":");
  if (
    ["reward points", "reward code", "reward link"].includes(title) &&
    !sorting
  ) {
    if (title === "reward link") {
      sorting = ["issued_date", "desc"];
    } else {
      sorting = ["generation_date", "desc"];
    }
  }

  return (
    <>
      {walletCompany === 1 ? (
        <div>
          {["payments", "reward points", "reward code", "gift cards"].includes(
            title
          ) && (
            <TotalData
              activeTab={activeTab}
              currencyCode={currencyCode}
              fetchCount={tableData?.fetchCount}
              isSuperAdmin={isSuperAdmin}
              title={title}
              walletCompany={walletCompany}
              columns={columns}
              filters={initialFetchParams}
            />
          )}
        </div>
      ) : (
        ""
      )}

      {type === "xoxo_token_report" && showHistoricalBanner && (
        <HistoricalBanner
          className="box mt-28"
          color="info"
          iconName="Info"
          buttons={
            <Icon
              iconName="PlumClose"
              onClick={() => setShowHistoricalBanner(false)}
            />
          }
          description={
            <>
              <div className="d-flex justify-content-between">
                <Typography.ButtonText
                  color="dark"
                  shade="c300"
                  className="mb-4"
                >
                  Historical Records
                </Typography.ButtonText>
              </div>
              <Typography className="mb-0">
                This table shows records of last{" "}
                {title === "payments" ||
                title === "invoice payments" ||
                title === "gift cards"
                  ? 6
                  : 12}{" "}
                months. You can access all available records under Download.
              </Typography>
            </>
          }
        />
      )}

      {isFirstRewardSent ||
      title === "payments" ||
      title === "invoice payments" ||
      title === "redemption history" ? (
        <ReportsFilter
          kyb_status={kyb_status}
          type={type}
          downloadReport={callDownloadReportData}
          preparingToDownload={preparingToDownload}
          count={count}
          reportsData={reportsData}
          columns={columns}
          tpdCustomColumns={tpdCustomColumns}
          setColumns={setColumns}
          applyFilter={applyFilter}
          activeTab={activeTab}
          selectedRows={selectedRows}
          title={title}
          categories={tableData.data}
          selectedCategory={selectedCategory}
          setSelectedCategory={setSelectedCategory}
          tableData={tableData}
          maxDownloadRows={maxDownloadRows}
          employee_email={employee_email}
          initialColumns={initialColumns}
          hideReportOptions={hideReportOptions}
          isFilterDisabled={isFilterDisabled}
          callDownloadReportData={callDownloadReportData}
          walletCompany={walletCompany}
        />
      ) : null}
      {(!loading && reportsData?.length === 0) || loading ? (
        <EmptyReports
          isFirstRewardSent={isFirstRewardSent}
          loading={loading}
          columns={columns}
          title={title}
          plumPro={plumPro}
          hasRecords={hasRecords}
          tableData={tableData}
          kyb_status={kyb_status}
        />
      ) : (
        <Table
          data={reportsData}
          columns={getUpdatedColumns(columns)}
          loading={loading}
          className="my-16 w-100"
          options={{
            print: false,
            elevation: 0,
            download: false,
            sort: true,
            filter: false,
            search: false,
            toolbar: false,
            viewColumns: false,
            selectableRows: tableData?.data[selectedCategory]?.showCheckBox
              ? "multiple"
              : "none",
            onCellClick: (colData, cellMeta) => {
              if (
                typeof colData?.props?.children === "string" &&
                colData?.props?.children?.toLowerCase() === "pay now"
              ) {
                profomaRecharge(cellMeta?.rowIndex);
              }
            },
            onRowClick: (rowData, rowMeta) => {
              setViewDetailModalData(reportsData[rowMeta.rowIndex]);
            },
            onRowSelectionChange: (
              currentRowsSelected,
              allRowsSelected,
              rowsSelected
            ) => {
              setSelectedRows(rowsSelected);
            },
            onColumnSortChange: (changedColumn, direction) => {
              let order = "desc";
              if (direction === "asc") {
                order = "asc";
              }
              setFetchParams({
                ...fetchParams,
                sorting: `${changedColumn}:${order}`,
              });
            },
            rowsPerPage: fetchParams.limit,
            rowsPerPageOptions: [
              initialFetchParams.limit,
              initialFetchParams.limit * 2,
              initialFetchParams.limit * 3,
              initialFetchParams.limit * 4,
              initialFetchParams.limit * 5,
              initialFetchParams.limit * 10,
            ],
            serverSide: true,
            count: count,
            page: fetchParams.offset / fetchParams.limit,
            customToolbarSelect: () => "",
            selectToolbarPlacement: "none",
            onTableChange: (action, tableState) => {
              if (action === "changePage") {
                setFetchParams({
                  ...fetchParams,
                  offset: tableState.page * tableState.rowsPerPage,
                });
              } else if (action === "changeRowsPerPage") {
                setFetchParams({
                  ...fetchParams,
                  offset: initialFetchParams.offset,
                  limit: tableState.rowsPerPage,
                });
              }
            },
            sortOrder: {
              name: (sorting && sorting[0]) || "",
              direction: (sorting && sorting[1]) || "",
            },
          }}
        />
      )}
      <Modal
        isOpen={downloadReports.emailSent}
        onClose={() => {
          setDownloadReports({ ...downloadReports, emailSent: false });
        }}
        disableCloseButton={false}
        timeout={0}
      >
        <Icon
          color="green"
          iconName="PlumCheckbox"
          padding="2px"
          shade="c300"
          size={46}
        />
        <Typography.H2 className="mt-4">Reports Sent!</Typography.H2>
        <Typography className="mt-12 mb-32">
          {downloadReports?.message}
        </Typography>
        <div className="d-flex justify-content-end">
          <Button
            color="primary"
            variant="outlined"
            onClick={() => {
              setDownloadReports({ ...downloadReports, emailSent: false });
            }}
          >
            Ok, Got it
          </Button>
        </div>
      </Modal>
      <UpdateReportPopup
        updateReportPopup={updateReportPopup}
        setUpdateReportPopup={setUpdateReportPopup}
        viewDetailModalData={viewDetailModalData}
        columns={columns}
        setColumns={setColumns}
        title={title}
        isBulk={selectedCategory == 1}
        selectedCategory={selectedCategory}
      />
      <ViewDetailModal
        setUpdateReportPopup={setUpdateReportPopup}
        activeTab={activeTab}
        viewDetailModalData={viewDetailModalData}
        currencyCode={currencyCode}
        showViewDetailModal={showViewDetailModal}
        setShowViewDetailModal={setShowViewDetailModal}
        columns={columns}
        setColumns={setColumns}
        title={title}
        moduleId={moduleId}
        type={type}
        isBulk={selectedCategory === 1}
        kyb_status={kyb_status}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  const { reportReducer: { adminList = [], xoxoCodeCampaign = [] } = {} } =
    state;
  return {
    adminList,
    xoxoCodeCampaign,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAdminList: () => fetchAdminList(),
      fetchCampaignList: () => fetchCampaignList(),
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(TableComponent);
